<template>
  <Modal
    v-model="setting_modal"
    :closable="false"
    :mask-closable="false"
    :styles="{top: '10px'}"
    width="40%"
  >
    <Row type="flex" align="top">
      <table class="lida-leading-table">
        <thead>
          <tr>
            <th colspan="2">{{ '站点设置' }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(it, i) in tableData" :key="i">
            <td width="35%">{{ it.sitesetname }}</td>
            <td v-if="it.SSTId == 30" class="text-left">
              <RadioGroup v-model="it.SSTVal" class="ma-1">
                <Radio :label="1">{{ '只A' }}</Radio>
                <Radio :label="2">{{ '只B' }}</Radio>
                <Radio :label="3">{{ 'A/B' }}</Radio>
              </RadioGroup>
            </td>
            <td v-else class="text-left">
              <RadioGroup v-model="it.SSTVal" class="ma-1">
                <Radio :label="1">{{ $t("common.open") }}</Radio>
                <Radio :label="2">{{ $t("common.close") }}</Radio>
              </RadioGroup>
            </td>
          </tr>
        </tbody>
      </table>
    </Row>
    <div slot="footer">
      <Button type="primary" @click="setting_modal = false">取消</Button>
      <Button type="error" @click="postSiteSettings" >确定</Button>
    </div>
  </Modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ModalSiteSettings',
  data () {
    return {
      setting_modal: false,
      tableData: [],
      mid: ''
    }
  },
  computed: {
    ...mapGetters(["getmember"]),
  },
  methods: {
    async getSiteSettings (id) {
      try {
        const res = await this.$axios.acount.sitesettings(id)
        if ('status' in res && res.status === 0) return
        res.data.forEach(it => {
          it['def_misve'] = it.SSTVal
        })
        this.tableData = res.data
        this.mid = id
        this.setting_modal = true
      } catch (error) {
        console.error(error)
      }
    },
    async postSiteSettings () {
      try {
        let misve = []
        this.tableData.forEach(it => {
          if (it['def_misve'] !== it.SSTVal) {
            let obj = {
              SSTId: Number(it.SSTId),
              SSTVal: Number(it.SSTVal)
            }
            misve.push(obj)
          }
        })
        if (!misve.length) return this.$Message.error('无修改')
        let obj = {
          loid: this.getmember.pid,
          mid: this.mid,
          misve,
        }
        const res = await this.$axios.acount.update_settings(obj)
        if (res.status !== 1) return
        this.$Message.success("成功")
        this.setting_modal = false
      } catch (error) {
        console.log(error);
        this.$Message.error("网路异常");
      }
    }
  }
}
</script>